"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconLaneDepartingWarning = function IconLaneDepartingWarning(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "30",
    className: className,
    height: "30",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.0943 7.54737C20.6711 7.03998 19.9204 6.8497 19.2652 7.12877L12.4674 10.0843C11.8122 10.3634 11.4846 11.023 11.6347 11.6573C9.99671 13.2682 9.49166 15.7164 10.57 17.8475L16.2485 29.137L16.4259 29.4921L22.1044 40.7816C23.1828 42.9127 25.5169 44.1177 27.9057 43.9909C27.9057 43.9909 33.2839 43.7752 37.3653 39.881C39.0033 38.27 39.5083 35.8219 38.43 33.6908L32.7515 22.4013L32.5741 22.0461L26.8956 10.7566C25.8172 8.61289 23.4694 7.40784 21.0943 7.54737ZM19.934 9.14566C21.572 8.60021 23.4694 8.99344 24.9027 10.1731C25.2576 10.4649 25.0255 10.985 24.5887 10.8835L20.0842 9.95749C19.6337 9.86869 19.5382 9.28519 19.934 9.14566ZM30.0351 20.2829L31.2091 22.6296L32.5604 25.3315C32.615 25.4457 31.7141 25.9911 31.6185 25.8896L30.4173 23.5049C30.3354 23.3273 30.2672 23.137 30.2399 22.9468L29.7894 20.3464C29.7621 20.2195 29.9669 20.1688 30.0351 20.2829ZM26.8137 16.1477C26.9912 16.1477 27.1549 16.2619 27.1822 16.4268L28.4108 21.3231C28.4654 21.5261 28.3152 21.729 28.0832 21.7544C26.4042 21.9066 24.7252 22.3125 23.1009 23.0102C21.4765 23.7205 20.0569 24.6592 18.8693 25.7501C18.7055 25.9023 18.4462 25.877 18.3097 25.712L15.0473 21.691C14.9381 21.5514 14.9517 21.3738 15.0609 21.247C16.4259 19.6868 18.2005 18.3675 20.3162 17.4542C22.432 16.5282 24.657 16.1096 26.8137 16.1477ZM11.3617 16.0462C11.3071 14.2703 12.1944 12.672 13.6959 11.8475C14.0645 11.6446 14.474 12.0885 14.2692 12.4564L12.1398 16.2745C11.9623 16.6551 11.389 16.4902 11.3617 16.0462ZM17.7773 28.8959L16.4259 26.1941C16.3713 26.0799 16.5351 25.9657 16.6307 26.0672L18.4325 28.008C18.5963 28.1856 18.7465 28.3885 18.8557 28.6042L20.0159 30.9255C20.0432 31.065 19.0195 31.3568 18.9512 31.2426L17.7773 28.8959ZM22.8142 38.917L19.5928 32.5111L20.5892 32.0798C20.5892 32.0798 21.3946 33.4371 22.2955 35.8219C22.4593 36.2024 22.8142 38.917 22.8142 38.917ZM36.0685 34.528C34.567 35.8092 32.7106 36.9762 30.5948 37.8895C28.479 38.8028 26.336 39.3863 24.3157 39.6273C24.1519 39.6527 24.0154 39.5893 24.0018 39.4751L23.5513 36.139C23.524 35.9995 23.7015 35.8345 23.9199 35.7965C25.5033 35.4794 27.1413 34.9847 28.7793 34.2743C30.4037 33.564 31.8643 32.7268 33.1474 31.7881C33.3248 31.6612 33.5705 31.6359 33.6661 31.75L36.1368 34.2109C36.2187 34.287 36.1777 34.4265 36.0685 34.528ZM36.519 32.9678C36.519 32.9678 34.5124 30.9636 34.2803 30.6084C32.888 28.4393 32.2874 26.9932 32.2874 26.9932L33.2839 26.5619L36.519 32.9678Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 6H3V17H7V6Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 20H3V31H7V20Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7 34H3V45H7V34Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 6H44V17H47V6Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 20H44V31H47V20Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47 34H44V45H47V34Z",
    fill: color
  }));
};

IconLaneDepartingWarning.defaultProps = {
  color: 'black'
};
IconLaneDepartingWarning.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconLaneDepartingWarning;
exports.default = _default;